export const checkIsPreviousDate = (firstDate: Date, secondDate: Date) =>
  firstDate < secondDate || firstDate.getTime() === secondDate.getTime();
